import { render, staticRenderFns } from "./AddResourceAssignmentModal.vue?vue&type=template&id=0906207c&"
import script from "./AddResourceAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./AddResourceAssignmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddResourceAssignmentModal.vue?vue&type=style&index=0&id=0906207c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports